export const card = [
  {
    image: "/assets/radio.png",
    titre: "RadioOhQuai",
    id: 1,
    lien: "https://becodeorg.github.io/PiloteMedia-Radioauquai/"
  },
  {
    image: "/assets/cookie.png",
    titre: "CookieChoco",
    id: 2,
    lien: "https://corneliushka.github.io/cookieChoco/"
  },
  {
    image: "/assets/restaurant.png",
    titre: "Restaurant Bootstrap",
    id: 3,
    lien: "https://frmassar.github.io/restaurantbstrp/"
  },
  {
    image: "/assets/ciné.png",
    titre: "AllezCiné",
    id: 4,
    lien: "https://github.com/Broodco/AllezCine"
  },
  {
    image: "/assets/tim.png",
    titre: "Tim Berners-Lee",
    id: 5,
    lien: "https://frmassar.github.io/starting-web-developpment/"
  },
  {
    image: "/assets/wiki.png",
    titre: "WikipediaApi",
    id: 6,
    lien: "https://frmassar.github.io/wikipediaApi/"
  }
];
